import { USER_STATUS } from "./userStatus";
const userStatusColorMap = {
    [USER_STATUS.ACTIVE]: "brand-success-600",
    [USER_STATUS.BLOCKED]: "brand-danger-500"
};
export default userStatusColorMap;
